<template>
  <main class="bg-white c-black">
    <div v-style:px="{ sm: '1.5rem', lg: '4rem' }">
      <div class="flex justify-center">
        <base-picture v-bind="hero" class="w-full" />
      </div>
      <div class="text-center">
        <div>
          <h1 class="mt-4 display-2">
            {{ getInTheFamily.title }}
          </h1>
          <base-picture v-bind="getInTheFamily.howItTitleLine" />
        </div>
        <p class="my-4">
          {{ getInTheFamily.unlock }}
        </p>
        <template v-if="user.isLoyaltyMember">
          <span>
            <vf-button :to="getInTheFamily.myAccount">
              {{ getInTheFamily.myAccountCta }}
            </vf-button>
          </span>
          <span class="ml-4">
            <vf-button :to="getInTheFamily.myDashboard">
              {{ getInTheFamily.myDashboardCta }}
            </vf-button>
          </span>
        </template>
        <template v-else>
          <span>
            <vf-button :to="getInTheFamily.joinNowUrl">
              {{ getInTheFamily.joinNowCta }}
            </vf-button>
          </span>
          <span class="ml-4">
            <vf-button :to="getInTheFamily.signInUrl">
              {{ getInTheFamily.signInCta }}
            </vf-button>
          </span>
        </template>
      </div>
      <div class="mt-10">
        <div class="gap-16 lg:flex">
          <div class="lg:w-1/2">
            <base-picture v-bind="getInTheFamily.picEarnPoints" class="w-full" />
            <div>
              <h2 class="mb-2 mt-4 subtitle-1">
                {{ getInTheFamily.worksTitle }}
              </h2>
              <base-picture v-bind="getInTheFamily.howItTitleLine" />
            </div>
            <h3 :class="titleTextClasses">
              {{ getInTheFamily.earnPoints }}
            </h3>
            <p>
              {{ getInTheFamily.getTenPoints }}
            </p>
            <h3 class="mt-6" :class="titleTextClasses">
              {{ getInTheFamily.redeemRewards }}
            </h3>
            <p v-for="({ rewards, key }) in redeem" :key class="my-1">
              {{ rewards }}
            </p>
            <h3 :class="titleTextBoldClasses">
              {{ getInTheFamily.unlockAccess }}
            </h3>
            <p class="mb-8">
              {{ getInTheFamily.getAdditional }}
            </p>
          </div>
          <div class="lg:w-1/2">
            <div>
              <base-picture v-bind="getInTheFamily.picFamilyAccess" class="w-full" />
            </div>
            <div>
              <h2 class="mb-2 mt-4 subtitle-1">
                {{ getInTheFamily.redeemTitle }}
              </h2>
              <base-picture v-bind="getInTheFamily.howToTitleLine" />
            </div>
            <h3 class="mt-6" :class="titleTextClasses">
              {{ getInTheFamily.onlineInApp }}
            </h3>
            <p>
              {{ getInTheFamily.selectAvailable }}
            </p>
            <h3 :class="titleTextBoldClasses">
              {{ getInTheFamily.inStore }}
            </h3>
            <p v-for="({ instore, key }) in redeem" :key class="my-2">
              {{ instore }}
            </p>
          </div>
        </div>
        <div class="mb-12 text-center text-sm">
          <base-link :to="getInTheFamily.seeTermsUrl">
            {{ getInTheFamily.seeTerms }}
          </base-link>
        </div>
      </div>
    </div>
    <section
      v-style:max-h="{ sm: '50rem', md: '55rem', lg: '60rem' }"
      class="relative overflow-hidden lg:h-xl"
    >
      <base-picture
        v-bind="getTheApp.bottomBanner"
        class="absolute-0"
        fit="cover"
      />
      <div class="px-6">
        <div>
          <div class="relative z-1 justify-center lg:mt-6 lg:w-full lg:flex lg:text-center">
            <div>
              <h2 class="mb-2 pt-8 subtitle-1">
                {{ getTheApp.title }}
              </h2>
              <base-picture v-bind="getTheApp.getAppLine" />
            </div>
          </div>
          <div class="mt-4 justify-center overflow-hidden lg:flex lg:flex-row-reverse lg:gap-16">
            <div class="relative lg:pt-10">
              <h3 class="mb-3 fw-bold title-2">
                {{ getTheApp.availableOn }}
              </h3>
              <vf-link :to="getTheApp.appleLink" variant="quieter">
                <base-picture v-bind="getTheApp.getAppleApp" />
              </vf-link>
              <vf-link :to="getTheApp.googleLink" variant="quieter">
                <base-picture v-bind="getTheApp.getGoogleApp" class="ml-2" />
              </vf-link>

              <div v-for="({ paragraph, title }, key) in getAppText" :key>
                <h3 :class="titleTextBoldClasses">
                  {{ title }}
                </h3>
                <p class="mb-8">
                  {{ paragraph }}
                </p>
              </div>
            </div>
            <div v-style:h="{ sm: '20rem', lg: '25.8rem' }" class="overflow-hidden">
              <base-video
                autoplay
                loop
                muted
                style="width: 24rem; mix-blend-mode: multiply"
                v-bind="getTheApp.getAppVideo"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script lang="ts" setup>
const { data, error } = await useApi().internal.getStaticPage('family')
if (!data.value) throw createError({ ...error.value!, fatal: true })
const { hero, getInTheFamily, redeem, getAppText, getTheApp } = data.value
const titleTextClasses = 'subtitle-3'
const titleTextBoldClasses = 'subtitle-3 mt-4 fw-bold'
const user = useUserStore()
</script>
